module.exports = __webpack_public_path__ + "assets/bannerless.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/bannerless.jpg
 ** module id = 107
 ** module chunks = 1
 **/